/** @format */

import {YalperExtendedPlatform, YalperPlatform} from 'graphql/generated/types';

interface Stats {
  extendedPlatform: YalperExtendedPlatform;
  platform: YalperPlatform;
  spent: number;
}

const getSpentSum = <S extends Stats>(stats?: ReadonlyArray<S> | null): number => {
  return (
    stats?.reduce((sum, stat) => {
      return stat.extendedPlatform === stat.platform ? sum + stat.spent : sum;
    }, 0) ?? 0
  );
};

export {getSpentSum};
